/**
 * It's not a bug, is a feature! :D
 * You must use a hook instead
 */
function HookUseDelayToNextFrame() {
  console.warn('Not meant to be used like this') // eslint-disable-line no-console
  return <div>Must use named import to use hooks</div>
}

HookUseDelayToNextFrame.displayName = 'HookUseDelayToNextFrame'

export default HookUseDelayToNextFrame
